'use strict'
import api from '@/api/api'
import posIndexedDB from '@/utils/posIndexedDB'

export default {
    async getPOSProducts(id) {

        const data = {
            method: 'get',
            url: 'pos-products/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getStockAndPriceUpdates(id) {
        const data = {
            method: 'get',
            url: 'pos-stock-price/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async updateCachedStockAndPrice(storeId, stockPriceUpdates) {
        try {
            return await posIndexedDB.updateStockAndPrice(storeId, stockPriceUpdates)
        } catch (error) {
            console.error('Error updating cached stock and price:', error)
            return null
        }
    },
    async getLastSale(reference = null) {
        let url = 'lastSale'
        if (reference) {
            url += `/${reference}`
        }
        const data = {
            method: 'get',
            url: url,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async requestCartOtp(storeId, data = {}) {
        const req = {
            method: 'post',
            url: 'pos/cart-otp/request/' + storeId,
            body: data,
        }

        const response = await api.api(req)
        if (response.status === 200) {
            return response.data
        }
    },
    async verifyCartOtp(storeId, data = {}) {
        const req = {
            method: 'post',
            url: 'pos/cart-otp/verify/' + storeId,
            body: data,
        }

        const response = await api.api(req)
        if (response.status === 200) {
            return response.data
        }
    },
}
